import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Expertise',
    href: '#expertise'
  }, {
    name: 'Experience',
    href: '#experience'
  }, {
    name: 'Impact',
    href: '#impact'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-navy/95 backdrop-blur-md py-4 shadow-sm' : 'bg-transparent py-6'}`} data-id="element-196">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-197">
        <a href="#" className="text-gold font-serif text-2xl tracking-wider font-medium" data-id="element-198">
          SG
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-199">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-softwhite/80 hover:text-gold text-sm uppercase tracking-widest transition-colors duration-300" data-id="element-200">
              {link.name}
            </a>)}
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-softwhite" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-201">
          {mobileMenuOpen ? <X size={24} data-id="element-202" /> : <Menu size={24} data-id="element-203" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-navy border-t border-white/10 p-6 flex flex-col space-y-6 shadow-xl" data-id="element-204">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-softwhite hover:text-gold text-sm uppercase tracking-widest transition-colors" onClick={() => setMobileMenuOpen(false)} data-id="element-205">
              {link.name}
            </a>)}
        </div>}
    </nav>;
}